import * as ProcessedSegment from './ProcessedSegment';

export default { ProcessedSegment };
